import React from 'react';
import { Button, Space } from 'antd';
import { ReactElement, memo } from 'react';
import { LeftOutlined } from '@ant-design/icons';

interface ParentLinkProps {
    name?: string;
    icon?: ReactElement;
    goBack: () => void;
}

const ParentLink = memo(({ name, goBack, icon }: ParentLinkProps) => {
    return (
        <Space
            size={16}
            style={{ display: 'flex' }}
        >
            <Button
                shape="round"
                icon={<LeftOutlined />}
                onClick={goBack}
            />
            {icon}
            {name && <h3 className="parent-link">{name}</h3>}
        </Space>
    );
});

export default ParentLink;
